import http, { url } from '../../http'

const API_URL = "subepp_ind"

class subepp2API {


  async getAllsubeppPage(ID, page) {
    const response = await http(`${API_URL}/${ID} ?page=${page}`, 'POST', {
      page: page
    })
    return response || null
  }
 

 
}

export default new subepp2API()